import { Card, Col, Divider, If, PageHeader, Row, Space, Spacer, Table, Tabs, Text } from '@app/components'
import { TabsProps } from '@app/types'
import { persistTabValue } from '@app/utils'
import { ColumnsType } from 'antd/es/table'
import { Unlock } from 'collections/discount/collections'
import { Fragment, useEffect, useState } from 'react'
import { useChainId } from 'wagmi'

export const Lock = ({ isForDrawer = true }) => {
  const chainId = useChainId()

  //work please
  const [activeTab, setActiveTab] = useState('unlock')

  useEffect(() => {
    setActiveTab('unlock')
  }, [])

  const items: TabsProps['items'] = [
    // {
    //   children: <TmpLock isForDrawer={isForDrawer} />,
    //   key: 'lock',
    //   label: 'Lock',
    // },
    {
      children: <Unlock isForDrawer={isForDrawer} />,
      key: 'unlock',
      label: 'Unlock',
    },
  ]

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    persistTabValue(value)
  }

  const columns: ColumnsType = [
    {
      dataIndex: 'action',
      title: 'Action',
    },
    // {
    //   dataIndex: 'asset',
    //   title: 'Asset',
    // },
    {
      dataIndex: 'fee',
      title: 'Fee',
    },
    // {
    //   dataIndex: 'tier2',
    //   title: 'Tier 2 (10k)',
    // },
    // {
    //   dataIndex: 'tier3',
    //   title: 'Tier 3 (1k)',
    // },
    // {
    //   dataIndex: 'tier4',
    //   title: 'Tier 4 (0)',
    // },
  ]

  /*const actions = [
      { action: 'Mint', asset: 'Wait', tier1: '1%', tier2: '2%', tier3: '3%', tier4: '4%' },
      { action: 'Burn', asset: 'Wait', tier1: '1%', tier2: '2%', tier3: '3%', tier4: '4%' },
      { action: 'Buy', asset: 'Wait', tier1: '1%', tier2: '2%', tier3: '3%', tier4: '4%' },
      { action: 'Eth Stablecoin Deposit', asset: 'eWait', tier1: '.25%', tier2: '.5%', tier3: '.75%', tier4: '1%' },
    ]*/

  const holidayActions = [
    //{ action: 'Wait Locked', asset: 'Wait', tier1: '100k', tier2: '10k', tier3: '1k', tier4: '0' },
    //{ key: 1, action: 'Mint', asset: 'Wait', tier1: '.25%', tier2: '.5%', tier3: '.75%', tier4: '1%' },
    //{ key: 2, action: 'Burn', asset: 'Wait', tier1: '1%', tier2: '2%', tier3: '3%', tier4: '4%' },
    { key: 1, action: 'Buy', asset: '', fee: '1%' },
    { key: 2, action: 'Sell', asset: '', fee: '2%' },

    // { key: 3, action: 'Deposit', asset: '', fee: '$3'},
    // { key: 4, action: 'OGP Deposit', asset: '', fee: '$0'},
    // { key: 5, action: 'Withdraw', asset: '', fee: '$5'},
    // { key: 6, action: 'OGP Withdraw', asset: '', fee: '$0'},
  ]

  return (
    <Row>
      <If condition={!isForDrawer}>
        <Col span={24}>
          <PageHeader
            title={'Fees'}
            disableBreadcrumb
            footer={
              <Fragment>
                <If
                  condition={
                    chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) &&
                    chainId != parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)
                  }
                >
                  <Row>
                    <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
                      <Space direction="vertical">
                        <Text strong>Please switch to PulseChain Mainnet or Ethereum Mainnet</Text>
                      </Space>
                    </Col>
                  </Row>
                </If>
                {chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) ? (
                  <>
                    <Text>
                      Reduce the fee to Mint & Burn $CST or Buy Pulsechain Assets by locking pWAIT on this page
                    </Text>
                  </>
                ) : (
                  <>
                    <Text>
                      Reduce the fee to fund your Digital Account with Eth-based Stablecoins by locking eWAIT on this
                      page
                    </Text>
                  </>
                )}

                <If
                  condition={
                    chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) ||
                    chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)
                  }
                >
                  <>
                    <Tabs centered activeKey={activeTab} items={items} onChange={handleTabChange} />
                    <Spacer />
                    <Divider />
                    <Spacer />
                    <Card id="holidayDiv" title="Platform Fees" bodyStyle={{ padding: 0 }}>
                      <Table columns={columns} dataSource={holidayActions} scroll={{ x: true }} pagination={false} />
                    </Card>
                  </>
                </If>
              </Fragment>
            }
          />
        </Col>
      </If>
    </Row>
  )
}
